/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1SerievideoVideoidLangsIdMutationResponse,
  DeleteApiV1SerievideoVideoidLangsIdPathParams,
  DeleteApiV1SerievideoVideoidLangsIdQueryParams,
  DeleteApiV1SerievideoVideoidLangsId401,
  DeleteApiV1SerievideoVideoidLangsId404,
  DeleteApiV1SerievideoVideoidLangsId500,
} from "../../types/serieVideoIdiomasController/DeleteApiV1SerievideoVideoidLangsId.ts";

function getDeleteApiV1SerievideoVideoidLangsIdUrl(
  videoId: DeleteApiV1SerievideoVideoidLangsIdPathParams["videoId"],
  id: DeleteApiV1SerievideoVideoidLangsIdPathParams["id"],
) {
  const res = {
    method: "DELETE",
    url: `/api/v1/serievideo/${videoId}/langs/${id}` as const,
  };
  return res;
}

/**
 * @description Remove uma tradução (idioma) do vídeo. **(Requer Authorization para autenticação)**
 * @summary Excluir idioma do vídeo (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/:videoId/langs/:id}
 */
export async function deleteApiV1SerievideoVideoidLangsId(
  videoId: DeleteApiV1SerievideoVideoidLangsIdPathParams["videoId"],
  id: DeleteApiV1SerievideoVideoidLangsIdPathParams["id"],
  params?: DeleteApiV1SerievideoVideoidLangsIdQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1SerievideoVideoidLangsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SerievideoVideoidLangsId401
      | DeleteApiV1SerievideoVideoidLangsId404
      | DeleteApiV1SerievideoVideoidLangsId500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1SerievideoVideoidLangsIdUrl(videoId, id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
